import { Event } from "../../api"

export const EVENTS_DOWNLOAD: string = "EVENTS_DOWNLOAD"

interface IEventDownload {
    type: string
    events: Event[]
}

export function setEventDownload(events: Event[]): IEventDownload {
    return { type: EVENTS_DOWNLOAD, events }
}
